
const SHOP_NAME_HANDLE = window.Shopify.shop.replace('.myshopify.com', '');
const LOCAL_STORAGE_KEY = `${ SHOP_NAME_HANDLE }_recentlyViewedProductHandles`;
const recently_viewed_section = document.querySelector('.recently-viewed-section');
const rec_prods = localStorage.getItem( LOCAL_STORAGE_KEY ) ? JSON.parse( localStorage.getItem( LOCAL_STORAGE_KEY ) ) : [];

// Tab JS
recently_viewed_section.addEventListener('click', (e) => {
  const target = e.target;
  if ( !target.classList.contains('heading-tab') ) return
  else {
    const tabIndex = target.dataset.tabIndex;
    const tabSlider = recently_viewed_section.querySelector(`.swiper[data-tab-index="${ tabIndex }"]`);
    const tabControls = recently_viewed_section.querySelector(`.swiper-controls[data-tab-index="${ tabIndex }"]`);
    
    // Reset Tabs
    const tabsAndSliders = recently_viewed_section.querySelectorAll('[data-tab-index]');
    tabsAndSliders.forEach( tab_or_slider => { tab_or_slider.classList.remove('active'); });
    
    if ( tabSlider ) {
      tabSlider.classList.add('active');
      tabControls.classList.add('active');
      target.classList.add('active');
    }
    
  }
});

// Intersection Observer Options
const options = {
	rootMargin: '100px'
}

// Observer Callback (Get Recent Products)
const observer = new IntersectionObserver(entry => {
  
  if (entry[0].isIntersecting == true) {
    observer.unobserve(recently_viewed_section)
    
    if (rec_prods && rec_prods.length > 0) {
      let recently_viewed = recently_viewed_section.querySelector('.recently-viewed-swiper.swiper .swiper-wrapper');
      
      const promises = rec_prods.map( async rec_prod => {
        let handle = rec_prod.replace(/"/g,'');
        return fetch(`${ window.Shopify.routes.root }products/${handle}?view=card&section_id=mous-product-card`)
        .then( response => {
          if ( response.ok ) {
            return response.text();
          } else {
            throw new Error("Error: " + response.status);
          }
        })
        .then( data => {
          const htmlDocument = new DOMParser().parseFromString( data, "text/html");
          const productCard = htmlDocument.documentElement.querySelector(".product-card");
          let url = window.location.href + "#";
          let swiper_slide = document.createElement("div");
          let title = productCard.querySelector('.product-title').innerText.trim().length;
          
          if(title < 1) {
            
          } else {
              swiper_slide.classList.add('swiper-slide');
              swiper_slide.insertAdjacentHTML(
                  'afterbegin',
                  productCard.outerHTML
              );
              
              if (productCard != url) {
                  
                  recently_viewed.insertAdjacentHTML(
                      'afterbegin',
                      swiper_slide.outerHTML
                  );
              }
          }
          
        })
        .catch(function (error) {
          window.log(error);
        });
      });
      
      Promise.all( promises )
        .then (() => {
            const recentlyViewed_swiper = new window.swiper('.recently-viewed-section .recently-viewed-swiper.swiper', {
                slidesPerView: 1.2,
                spaceBetween: 20,
                
                navigation: {
                  nextEl: '.recently-viewed-navigation.swiper-button-next',
                  prevEl: '.recently-viewed-navigation.swiper-button-prev',
                },
                
                breakpoints: {
                    500: {
                        slidesPerView: 2.2,
                    },
                    1028: {
                        slidesPerView: 3,
                    },
                    1280: {
                        slidesPerView: 4,
                    },
                },
                
            });
            
            // yotpo.initWidgets();
        });
        
    } else {
      // No recently viewd products
      let allTabs = recently_viewed_section.querySelectorAll('.heading-tab');
      
      if ( allTabs.length > 1 ) {

        const recentlyViewedTab = recently_viewed_section.querySelector('.recently-viewed.heading-tab');
        const recentlyViewedIndex = recentlyViewedTab.dataset.tabIndex;
        
        const recentlyViewedEls = recently_viewed_section.querySelectorAll(`[data-tab-index="${ recentlyViewedIndex }"]`);
        
        // Remove RecentlyViewed Elements
        recentlyViewedEls.forEach( recentlyViewedEl => recentlyViewedEl.remove() );
        
        allTabs = recently_viewed_section.querySelectorAll('.heading-tab')[0].click();
        
      } else {
        // No Tabs Section is Empty
        recently_viewed_section.remove();
      }
      
      
    }
    
      // Init Other Collection Swipers
      const collectionSwipers = recently_viewed_section.querySelectorAll('.swiper:not(.recently-viewed-swiper)');
      if ( collectionSwipers && collectionSwipers.length > 0 ) {
        collectionSwipers.forEach( collectionSwiper => {
          const swiperTabIndex = collectionSwiper.dataset.tabIndex;
          const swiperClass = `.collection-${ swiperTabIndex }-swiper`;
          const swiperNavClass = `.collection-${ swiperTabIndex }-navigation`;

          console.log('swiperClass: ', swiperClass, ' | swiperNavClass: ', swiperNavClass )
          
          new window.swiper( swiperClass, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            
            navigation: {
              nextEl: `${ swiperNavClass }.swiper-button-next`,
              prevEl: `${ swiperNavClass }.swiper-button-prev`,
            },
            
            breakpoints: {
              500: {
                  slidesPerView: 2.2,
              },
              1028: {
                  slidesPerView: 3,
              },
              1280: {
                  slidesPerView: 4,
              },
            },
            
          });
        });
        
      }
    
  }
  
}, options);

// Set up Observer
observer.observe(recently_viewed_section);